import React from 'react';

export const MERCHANT_TYPES = {
	ZUPEE: 'ZUPEE',
	EXTERNAL: 'EXTERNAL',
	MARKETING: 'MARKETING'
} as const;

interface IMerchantContext {
	merchantName: string;
}

const MerchantContext = React.createContext<IMerchantContext>({} as IMerchantContext);

export default MerchantContext;
